import { render, staticRenderFns } from "./AddItems.vue?vue&type=template&id=811beebc&"
import script from "./AddItems.vue?vue&type=script&lang=js&"
export * from "./AddItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports